import { CultureEntry } from 'interfaces/cultures';

export const isCultureOptionDisabled = (
  entries: CultureEntry<string>[],
  code: string
) => {
  return entries.map((p) => p.culture).includes(code);
};
